export class ResponseNewFaseEstrategicaModel{
    payload:NewFaseEstrategicaModel;

    constructor(){
        this.payload = new NewFaseEstrategicaModel();
    }
}

export class NewFaseEstrategicaModel{    
    idPlanMejora:number;
    idJardinPeriodo:number;
    estado:number;
    dimensiones:DimensionesPMEModel[];
    constructor(){
        this.idPlanMejora = -1;
        this.idJardinPeriodo = -1;
        this.estado = -1;
        this.dimensiones = new Array<DimensionesPMEModel>();
    }
}

export class DimensionesPMEModel{    

    dimension:string;
    idDimension:number; 
    orden:number;
    subdimensiones:SubdimensionPMEModel[];
    constructor(){
        this.dimension = "";
        this.idDimension = -1;
        this.orden = -1;
        this.subdimensiones = new Array<SubdimensionPMEModel>();
    }
}

export class SubdimensionPMEModel{    

    idSubDimensionPME:number;
    orden:number;
    idObjetivoPME:number;
    nombreCorto:string;
    subDimension:string;
    priorizada:boolean;
    objetivo:string;
    meta1:string;
    meta2:string;
    meta3:string;
    meta4:string;
    disabled:boolean;
    disabledSiempre:boolean;
    disabledObjetivo:boolean;
    disabledPriorizar:boolean;
    disabled2026:boolean;
    constructor(){
        this.idSubDimensionPME = -1;
        this.orden = -1;
        this.idObjetivoPME = -1;
        this.nombreCorto = "";
        this.subDimension = "";
        this.priorizada = false;
        this.objetivo = "";
        this.meta1 = "";
        this.meta2 = "";
        this.meta3 = "";
        this.meta4 = "";
        this.disabled=false;
        this.disabledSiempre= false;
        this.disabledObjetivo= false;
        this.disabledPriorizar= false;
        this.disabled2026= false;
    }

}
